(function () {
    if ($('#partner-bookings-page').length) {
        $('#logo_name').on('click', () => {
            $('#logo').trigger('click');
        });

        $('#logo_name').on('keydown', e => {
            e.preventDefault();
        });

        $('#logo').on('change', function (e) {
            $('#logo_name').val(e.target.files[0].name);
            $('#logo_name').trigger('blur');
        });
    }
})();
